/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Plans_FreeInputs */

const es_admin_company_overview_plans_free = /** @type {(inputs: Admin_Company_Overview_Plans_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const en_admin_company_overview_plans_free = /** @type {(inputs: Admin_Company_Overview_Plans_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Admin_Company_Overview_Plans_FreeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_plans_free = /** @type {((inputs?: Admin_Company_Overview_Plans_FreeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Plans_FreeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_plans_free(inputs)
	return en_admin_company_overview_plans_free(inputs)
});
export { admin_company_overview_plans_free as "admin.company_overview.plans.free" }